import { z } from "zod";

export const sendExternalMessagePayloadSchema = z.object({
  channel: z.enum(["email", "sms", "webhook"]),
  recipient: z.string().min(1),
  subject: z.string().min(1).optional(),
  body: z.string().min(1)
});

export type SendExternalMessagePayload = z.infer<typeof sendExternalMessagePayloadSchema>;
